var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');
var _ = require('underscore');


exports.GetApplicantDetails = function(){
  return request.get(resolve(config.url(), '/applicants/current?viewName=ApplicantOrganisationView')).promise();
}

exports.GetOwnApplicant = function(viewName) {
  var query = {
    viewName: viewName,
  }

  return request.get(resolve(config.url(), '/applicants/current'), query).promise();
}

exports.GetApplicantById = function(id, viewName) {
  var query = {
    viewName: viewName
  }

  return request.get(resolve(config.url(), '/applicants/' + id), query).promise();
}

exports.GetApplicantByUserRef = function(userRef, viewName) {
  var query = {
    viewName: viewName
  }

  return request.get(resolve(config.url(), '/applicants/byUserRef/' + userRef), query).promise();
}

exports.GetAdminApplicants = function(filter, includeVerified, order, viewName, page, pageSize){
  var qry = {
    viewName: viewName,
    filter: filter,
    includeVerified: includeVerified,
    order: order,
    page: page,
    pageSize: pageSize
  }
	return request.get(resolve(config.url(), '/applicants'), qry).promise();
}

exports.GetApplicants = function(){
	return request.get(resolve(config.url(), '/users/self/applicants')).promise();
}


exports.GetApplicantsForTypeahead = function(filter){
	return request.get(resolve(config.url(), '/applicants/typeahead/?filter=' + filter)).promise();
}



exports.AddGalleryItem = function(applicantId, item) {
  return request.post(resolve(config.url(), "/applicants/" + applicantId + "/galleryitems"), item).promise();
};
exports.UpdateGalleryItem = function(applicationId, itemId, item) {
  var url = resolve(config.url(), "/applicants/" + applicationId + "/galleryitems/" + itemId);
  return request.put(url, item).promise();
};
exports.DeleteGalleryItem = function(applicantId, itemId) {
  var url = resolve(config.url(), "/applicants/" + applicantId + "/galleryitems/" + itemId);
  return request.del(url).promise();
};

exports.UpdateApplicationSummary = function(id, rqst) {
  return request.put(resolve(config.url(), "/applicants/" + id + "/about"), rqst).promise();
};




exports.GetProjects = function(applicantId, filter, viewName, pageNumber, pageSize) {
  var qry = {
    filter: filter
  };
  if (viewName) qry.viewName = viewName;
  if (pageNumber) qry.pageNumber = pageNumber;
  if (pageSize) qry.pageSize = pageSize;

  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/projects'), qry).promise();
}

exports.CreateApplicant = function(organisation) {
    return request.post(resolve(config.url(), '/applicants'), organisation).promise();
}

exports.SaveApplicant = function(organisation) {
	if (organisation.applicantId)
        return request.put(resolve(config.url(), '/applicants/' + organisation.applicantId), organisation).promise();
    else
        return request.post(resolve(config.url(), 'applicants'), organisation).promise();
}

exports.UpdateApplicant = function(organisation)
{
  return request.put(resolve(config.url(), '/applicants/' + organisation.applicantId), organisation).promise();
}

exports.GetApplicantOrganisation = function (applicantId) {
	var qry = {
		viewName: "ApplicantOrganisationView"
	}
	return request.get(resolve(config.url(), 'applicant'), qry).promise();
  }

exports.VerifyApplicant = function(id){
  return request.put(resolve(config.url(), 'applicants/' + id + '/verify')).promise();
}

exports.ApplicantLogs = function(id){
  return request.get(resolve(config.url(), '/applicants/' + id + '/log')).promise();
}

exports.ApplicantLatestLog = function(id) {
	return request.get(resolve(config.url(), '/applicants/' + id + '/log/latest')).promise();
}

exports.registerQuestionsCompleted = function() {
  return request.put(resolve(config.url(), '/applicants/registrationquestions'),  { haveBeenAnswered:true }).promise();
}

exports.GetApplicantUsers = function(applicantId) {
  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/users')).promise();
}

exports.RemoveApplicantUser = function(applicantId, userId) {
  return request.del(resolve(config.url(), '/applicants/' + applicantId + '/users/' + userId)).promise();
}

exports.ManageApplicantUserClaims = function(applicantId, userId, claim, hasClaim){
  //{id}/users/{userId}
  var qry = {
    claim: claim,
    hasClaim: hasClaim
  }
  return request.put(resolve(config.url(), '/applicants/' + applicantId + '/users/' + userId), qry).promise();
}

exports.InviteUserToJoinApplicant = function (applicantId, emailAddress) {
  var inviteUrl = resolve(config.baseUrl(), '/applicant-invite');
  var qry = {
    emailAddress: emailAddress,
    inviteUrl: inviteUrl
  };
  return request.post(resolve(config.url(), 'applicants/' + applicantId + '/inviteuser'), qry).promise().catch(function (err) {
    throw new Error(err.body.message);
  });
};

exports.UpdateUserFinanceContact = function (applicantId, userId, isFinanceContact) {
  var qry = {
    userId: userId,
    isFinanceContact: isFinanceContact
  };
  return request.post(resolve(config.url(), 'applicants/' + applicantId + '/financeContact'), qry).promise().catch(function (err) {
    throw new Error(err.body.message);
  });
};

exports.GetInvitationDetails = function(invitationId){
  return request.get(resolve(config.url(), '/applicants/invite/' + invitationId)).promise();
}

exports.GetInvites = function(applicantId){
  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/invites')).promise();
}


exports.AddInvitedApplicantUser = function(applicantId, invitationId) {
  var qry = {
    inviteId: invitationId
  }
  return request.post(resolve(config.url(), '/applicants/' + applicantId + '/inviteduser'), qry).promise();
}

exports.GetAdminUsers = function(applicantId){
  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/adminusers')).promise();
}

exports.RequestApplicantInvitation = function(applicantId, contactName, contactNumber, email, position){
  var req = {
    applicantId: applicantId,
    contactName: contactName,
    contactNumber: contactNumber,
    email: email,
    position: position
  };
  return request.put(resolve(config.url(), "/applicants/requestapplicantinvite"), req).promise();
}


exports.GetInvoiceDocuments = function(applicantId, pageNumber, pageSize){
  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/documents/invoices'), {pageNumber: pageNumber, pageSize: pageSize || 5}).promise();
}

exports.GetInvoices = function(applicantId, viewName) {
  return request.get(resolve(config.url(), '/applicants/' + applicantId + '/invoices'), { viewName: viewName }).promise();
}

exports.RemoveApplicantInvitation = function(applicantId, inviteId) {
  return request.del(resolve(config.url(), '/applicants/' + applicantId + '/invite/' + inviteId)).promise();
}

exports.UpdateFinancials = function(organisation)
{
  return request.put(resolve(config.url(), '/applicants/' + organisation.applicantId + '/financials'), organisation).promise();
}
